<template>
    <div>
        <vs-popup class="holamundo" title="Add New Channel" :active.sync="popupActivo">
            <vx-input-group class="mb-3">
                <ul class="con-s">
                    <li>
                        <label for="">Featured Channel</label>
                        <vs-switch v-model="ch.featured" vs-icon-off="moon" vs-icon-on="moon" />
                    </li>
                    <li>
                        <label for="">Editor Choice</label>
                        <vs-switch v-model="ch.editor_choice" vs-icon-off="moon" vs-icon-on="moon" />
                    </li>
                    <li>
                        <label for="">For Kids</label>
                        <vs-switch v-model="ch.kids" vs-icon-off="moon" vs-icon-on="moon" />
                    </li>
                </ul>
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-input v-model="ch.name" placeholder="Channel Name" />
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-input v-model="ch.ar_name" placeholder="Arabic Name" />
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-input v-model="ch.stream_link" placeholder="Stream Link" />
            </vx-input-group>
            <vx-input-group class="mb-3">
                Logo:
                <input type="file" class="form-control-file" ref="logo" v-on:change="handleLogo()">
            </vx-input-group>
            <vx-input-group class="mb-3">
                Image:
                <input type="file" class="form-control-file" ref="image" v-on:change="handleImage()">
            </vx-input-group>
            <vx-input-group class="mb-3">
                Secondary Image:
                <input type="file" class="form-control-file" ref="secImage" v-on:change="handleSecondaryImage()">
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-button color="warning" type="filled" @click="addChannel">Save</vs-button>
            </vx-input-group>
        </vs-popup>

        <vs-button color="success" @click="popupActivo = true" size="small">Add Channel</vs-button> <br />
        <vs-row vs-type="flex">
            <vs-col v-for="channel in pkg.channels" :key="channel" vs-order="3" vs-type="flex" vs-justify="center"
                vs-align="center" vs-w="2" class="card shadow-lg  p-2 m-1"
                style="border: 1px solid #ccc;border-radius: 15px;">

                <img class="card-img-top " :src="channel.image" width="80" alt="Card image cap">
                <div class="card-body">
                    <h4 class="card-title">{{channel.name}}</h4>
                    <p class="card-text">

                    </p>
                    <div class="flex justify-content-center ">
                        <vs-button radius color="danger" type="filled" icon="delete" size="small"
                            @click="openConfirm(channel)"></vs-button>
                        <vs-button class="mx-1" radius color="warning" type="filled" icon="edit" size="small"
                            @click="editPackage(channel)"></vs-button>
                    </div>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
    export default {
        props: ['pkg'],
        data() {
            return {
                popupActivo: false,
                ch: {
                    id: 0,
                    featured: false,
                    kids: false,
                    editor_choice: false,
                    name: "",
                    ar_name: "",
                    stream_link: '',
                    image: "",
                    secondary_image: "",
                    logo: "",
                },
            }
        },
        methods: {
            updateSequence() {
                var ids = [];
                for (let index = 0; index < this.pkg.channels.length; index++) {
                    const element = this.pkg.channels[index];
                    ids.push(element.id);
                }
                // this.$store.dispatch("Tv/updatePackagesSequence", {
                //     data: ids,
                // });
            },
            editPackage(pack) {
                this.popupActivo = true;
                this.ch = pack;
            },
            addChannel() {
                this.$vs.loading();
                const data = new FormData();
                data.append('id', this.ch.id);
                data.append('name', this.ch.name);
                data.append('ar_name', this.ch.ar_name);
                data.append('stream_link', this.ch.stream_link);
                data.append('featured', this.ch.featured ? 1 : 0);
                data.append('kids', this.ch.kids ? 1 : 0);
                data.append('editor_choice', this.ch.editor_choice ? 1 : 0);
                data.append('package_id', this.pkg.id);
                if (typeof this.ch.logo != 'string' || !this.ch.logo instanceof String) {
                    if (this.ch.logo) {
                        data.append('logo', this.ch.logo);
                    }

                }
                if (typeof this.ch.image != 'string' || !this.ch.image instanceof String) {
                    if (this.ch.image != null) {
                        data.append('image', this.ch.image);
                    }

                }
                if (typeof this.ch.secondary_image != 'string' || !this.ch.secondary_image instanceof String) {
                    if (this.ch.secondary_image != null) {
                        data.append('secondary_image', this.ch.secondary_image);
                    }

                }


                this.axios.post(`${this.$apiUrl}/v2/tv/channels`, data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    this.$vs.loading.close();

                    this.$vs.notify({
                        color: 'success',
                        title: 'Chaneel Addedd/Updated',
                        text: ''
                    })


                    this.$store.dispatch("Tv/fetchPackages", {
                        page: 1,
                    });

                }).catch(err => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error When Add',
                        text: ''
                    })
                });
                this.popupActivo = false;

            },
            handleImage() {
                this.ch.image = this.$refs.image.files[0];
            },
            handleSecondaryImage() {
                this.ch.secondary_image = this.$refs.secImage.files[0];
            },
            handleLogo() {
                this.ch.logo = this.$refs.logo.files[0];
            },
            openConfirm(ch) {
                this.ch = ch;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Delete Channel`,
                    text: 'Are you sure to delete this item ?',
                    accept: this.del,
                    close: this.close
                })
            },
            del(id) {
                this.axios.post(`${this.$apiUrl}/v2/tv/channels/${this.ch.id}/del`).then(res => {
                    this.ch = {
                        id: 0,
                        featured: 0,
                        kids: 0,
                        editor_choice: 0,
                        name: "",
                        ar_name: "",
                        stream_link: '',
                        image: "",
                        secondary_image: "",
                        logo: "",
                    };
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'warning',
                            title: 'Channel Deleted !',
                            text: ''
                        })
                    }
                    this.$store.dispatch("Tv/fetchPackages", {
                        page: 1,
                    });

                })

            },
        },
    }
</script>